import { render, staticRenderFns } from "./InvestorContentCN.vue?vue&type=template&id=6226c45c&scoped=true"
import script from "./InvestorContentCN.vue?vue&type=script&lang=js"
export * from "./InvestorContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226c45c",
  null
  
)

export default component.exports